var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-buttons"},[_c('div',{staticClass:"action-icon wechat-icon bg-white"},[_c('img',{staticStyle:{"width":"30px"},attrs:{"src":require("@/assets/icons/kf.png"),"alt":"客服"}}),_c('div',{staticClass:"hover-image"},[_c('img',{attrs:{"src":require("@/assets/images/kf.png"),"alt":"客服二维码"}})])])])
}]

export { render, staticRenderFns }